import { h, Fragment } from 'preact';
import Icons from '../../../components/Icons/Icons';
import Typography from '../../../components/Typography/Typography';
import parse from 'html-react-parser';

/**
 * ArticleQuote component renders a styled quote block with text and quote mark icons.
 *
 * @param {Object} props - The props object.
 * @param {string} props.text - The text content of the quote.
 * @returns {JSX.Element} A styled quote block with text and decorative quote marks.
 */

export const ArticleQuote = ({ text }) => {
  return (
    <div className="tw:flex tw:w-[790px] tw:max-w-full tw:pr-[19px] tw:md:space-y-3 tw:md:px-0">
      <Icons.quoteMarks classname="tw:mb-4 tw:md:h-[80px] tw:w-[48px] tw:h-[50px] tw:md:w-[78px] tw:flex-shrink-0 tw:text-primary" />

      {text && <div className="tw:py-3">
        <Typography
          domtype="h3"
          classname="tw:text-primary tw:md:leading-[120%] tw:pr-4 tw:md:pr-0"
        >
          {parse(text)}
          <Icons.quoteMarks classname="tw:md:h-[80px] tw:w-[48px] tw:h-[50px] tw:md:w-[78px] tw:flex-shrink-0 tw:text-primary tw:rotate-180 tw:float-end tw:md:-mt-3 tw:md:mr-2 tw:mr-10 tw:-mt-[10px]" />
        </Typography>
      </div>}
    </div>
  );
};
